import axios from 'axios'
import router from '../router'
import store from '../store'
import qs from 'qs'
import {Message} from 'element-ui'


const env = process.env.NODE_ENV;
let hostname = window.location.hostname;
let baseUrl ='/';

if(env == 'production'){
  if(hostname=='www.rongzhidui.com'){
    baseUrl='https://qy.rongzhidui.com/'
  }else{
    // baseUrl='http://vv.bangongyi.com/'
    baseUrl='https://qy.rongzhidui.com/'

  }
}

const $axios = axios.create({
  baseURL: baseUrl
});

// 请求
$axios.interceptors.request.use(
  request => {
    if(request.url=='/loans/upload/uploadimage'){
      request.headers['Content-Type'] = 'multipart/form-data';
    }else{
      request.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      request.data=qs.stringify(request.data);

    }
    request.headers["token"] = localStorage.loginToken ? localStorage.loginToken : "";
    request.headers['ispc']='1';
    return request
  }
);
//  响应
$axios.interceptors.response.use((res) => {
  const code = res.data.code;
  if(code && code!=200){
    if(code == '-302'){
      if(location.href.indexOf('enterprise')==-1){
        router.push({ path: '/login' });
      }
      store.commit('setLogin',false);
      localStorage.clear();
    }
    Message.error({message: res.data.msg});
  }
  return res;
})
export default $axios;
